export const pricingCTAData = {
  sellingPoints: [
    'Planning Dashboard',
    'Wedding Website',
    'All-in-One Registry',
    'Mobile App',
    'Unlimited Guests',
    'Digital Invites and RSVP',
    'Multiple Editor Accounts',
    'Unlimited Photo Storage',
    'Personal Customer Support',
  ],
} as const;
